import { useEffect } from "react";
import CustomBreadcrumb from "../../../components/customBreadcrumb/CustomBreadcrumb";
import Title from "../../../components/title/Title";

const UserGuide = () => {
  const userGuideUrl = "https://online.flippingbook.com/view/862489688/";

  useEffect(() => {
    // Open the user guide in a new tab when the component mounts
    window.open(userGuideUrl, "_blank", "noopener,noreferrer");
  }, []);

  return (
    <div className="page-container">
      <CustomBreadcrumb
        items={[
          { path: "/", title: "Home" },
          {
            path: "/settings/userGuide",
            title: "User Guide",
          },
        ]}
      />
      <Title>User Guide</Title>
      <div style={{ textAlign: "center", padding: "20px" }}>
        <p>Opening the User Guide in a new tab...</p>
        <p>
          {" "}
          <a
            href={userGuideUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#1E4894", textDecoration: "underline" }}
          >
            click here
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default UserGuide;

